import { useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export const ENQUIRY_FORM_ID = "enquiry-form";

// Primary conversion action. Navigates to /contact, or — when already on the
// Contact page — smooth-scrolls to the enquiry form.
export const useBookConsultation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(() => {
    if (location.pathname === "/contact") {
      const el = document.getElementById(ENQUIRY_FORM_ID);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      navigate("/contact");
    }
  }, [navigate, location.pathname]);
};
